import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';


@Injectable()
export class EnvironmentHelperService {
	constructor() {
	}

	public getCountryCodesForEnvironment() {
		switch (environment.env) {
			case 'local':
			case 'development':
			case 'production':
				return ['AU', 'NZ', 'PH'];
			case 'ushergroup':
				return ['AU'];
			case 'na':
				return ['US'];
			case 'uk':
				return ['GB'];
			default:
				return ['AU', 'NZ', 'PH', 'GB', 'US'];
		}
	}

	public getEnvironmentDefaultTimezone() {
		return environment.defaultTimezone;
	}
}